exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation[data-v-4033587a]{overflow:hidden}.nav[data-v-4033587a]{min-height:48px}.nav .txt[data-v-4033587a]{text-align:center;line-height:36px;position:relative}.nav .txt .bg[data-v-4033587a]{position:absolute;width:20px;height:3px;left:50%;margin-left:-10px;bottom:0;border-radius:2px}.nav .img img[data-v-4033587a]{width:100%;height:100%;display:block}.nav .img-view[data-v-4033587a]{width:100%;height:100%;background:#eaeef4}.nav .img-view img[data-v-4033587a]{width:24px;height:24px;display:block}.nav .item[data-v-4033587a]{-ms-flex-negative:0;flex-shrink:0}\n", ""]);

// exports
